import { motion } from "framer-motion";
import { Home, MapPin, Search, UserRound } from "lucide-react";

export function SearchBar({ searchFilters, setSearchFilters }) {
  return (
    <section className="relative z-10 -mt-10 mb-8" data-testid="search-bar-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="bg-white shadow-[0_2px_20px_rgba(0,0,0,0.06),0_8px_40px_rgba(0,0,0,0.04)] rounded-md p-5 md:p-7 flex flex-col md:flex-row gap-5 items-end border border-gray-100/80"
        >
          <div className="flex-1 w-full">
            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Ville</label>
            <div className="relative">
              <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Ex: Limoges"
                value={searchFilters.ville}
                onChange={(e) => setSearchFilters({ ...searchFilters, ville: e.target.value })}
                className="w-full pl-10 pr-4 py-3 border border-gray-200/80 focus:border-[#C9922A]/60 focus:ring-2 focus:ring-[#C9922A]/8 outline-none transition-all text-sm rounded-sm bg-[#FAFAF8]/50"
                data-testid="search-ville"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Type</label>
            <div className="relative">
              <Home className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <select
                value={searchFilters.type_logement}
                onChange={(e) => setSearchFilters({ ...searchFilters, type_logement: e.target.value })}
                className="w-full pl-10 pr-4 py-3 border border-gray-200/80 focus:border-[#C9922A]/60 focus:ring-2 focus:ring-[#C9922A]/8 outline-none transition-all text-sm appearance-none bg-[#FAFAF8]/50 rounded-sm"
                data-testid="search-type"
              >
                <option value="">Tous les types</option>
                <option value="studio">Studio</option>
                <option value="appartement">Appartement</option>
                <option value="maison">Maison</option>
              </select>
            </div>
          </div>

          <div className="flex-1 w-full">
            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Voyageurs</label>
            <div className="relative">
              <UserRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <select
                value={searchFilters.capacite_min}
                onChange={(e) => setSearchFilters({ ...searchFilters, capacite_min: e.target.value })}
                className="w-full pl-10 pr-4 py-3 border border-gray-200/80 focus:border-[#C9922A]/60 focus:ring-2 focus:ring-[#C9922A]/8 outline-none transition-all text-sm appearance-none bg-[#FAFAF8]/50 rounded-sm"
                data-testid="search-capacite"
              >
                <option value="">Nombre de voyageurs</option>
                <option value="1">1+ voyageur</option>
                <option value="2">2+ voyageurs</option>
                <option value="4">4+ voyageurs</option>
                <option value="6">6+ voyageurs</option>
              </select>
            </div>
          </div>

          <button
            onClick={() => document.getElementById("logements-grid")?.scrollIntoView({ behavior: "smooth" })}
            className="btn-primary inline-flex items-center gap-2.5 whitespace-nowrap"
            data-testid="search-btn"
          >
            <Search className="w-4 h-4" /> Chercher
          </button>
        </motion.div>
      </div>
    </section>
  );
}
